import React from "react";
import { ScrollText } from "lucide-react";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <div className="flex items-center gap-3 mb-2">
        <ScrollText className="w-8 h-8 text-[#e86a24]" />
        <h1 className="text-3xl md:text-4xl font-black text-[#1d3d3a]">Termini di Servizio</h1>
      </div>
      <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: 25 maggio 2026</p>

      <div className="space-y-6 text-slate-700">
        <Section title="1. Accettazione">
          <p>
            Utilizzando SAN MARINO MARKET accetti integralmente questi Termini e l'Informativa Privacy. Se non accetti, ti preghiamo di non utilizzare il servizio.
          </p>
        </Section>

        <Section title="2. Servizio">
          <p>
            SAN MARINO MARKET è una piattaforma <strong>esclusiva per la Repubblica di San Marino</strong> che mette in contatto privati e aziende per la compravendita di beni, il baratto e la partecipazione ad aste. Non siamo parte delle transazioni: ogni accordo è esclusivamente tra venditore e acquirente.
          </p>
        </Section>

        <Section title="3. Requisiti dell'utente">
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Devi avere almeno 18 anni o essere autorizzato da un genitore/tutore.</li>
            <li>Risiedere o operare in Repubblica di San Marino.</li>
            <li>Fornire dati veritieri e mantenerli aggiornati.</li>
            <li>Mantenere riservate le tue credenziali di accesso.</li>
            <li>Le aziende devono essere registrate con P.IVA italiana o COE sammarinese valido.</li>
          </ul>
        </Section>

        <Section title="4. Responsabilità sui contenuti pubblicati">
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded text-sm space-y-2">
            <p>
              <strong>Mi assumo ogni responsabilità sulla merce, sui marchi e sui prodotti caricati.</strong> Pubblicando un annuncio, l'utente dichiara espressamente di farsi carico della legittimità, autenticità e conformità dei beni offerti.
            </p>
            <p>
              <strong>SAN MARINO MARKET (sanmarinomarket.com) non si assume alcuna responsabilità</strong> sulla merce pubblicata, sulla sua conformità a leggi nazionali o europee, sulla qualità, sull'autenticità o sull'esito delle transazioni tra utenti.
            </p>
            <p>
              È <strong className="text-red-700">tassativamente vietato</strong> l'inserimento all'interno della piattaforma di <strong>prodotti contraffatti</strong> (falsi o imitazioni non autorizzate di marchi registrati). Tale comportamento costituisce reato penale (artt. 473-474 c.p. italiano; artt. 167-168 c.p. sammarinese) e comporta:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Rimozione immediata dell'annuncio.</li>
              <li>Sospensione o cancellazione definitiva dell'account, senza preavviso e senza diritto a rimborso degli abbonamenti Azienda.</li>
              <li>Segnalazione alle autorità competenti (Polizia Civile sammarinese, Guardia di Finanza italiana, titolari dei marchi).</li>
            </ul>
            <p>
              È inoltre <strong>vietato</strong> pubblicare oggetti illegali, rubati, armi, droghe, animali protetti, sostanze pericolose, parti del corpo umano, alimenti deperibili senza autorizzazione, o contenuti che violino diritti di terzi (incluso copyright, marchi registrati, brevetti).
            </p>
            <p>
              All'atto della pubblicazione di ogni annuncio l'utente accetta esplicitamente questa dichiarazione tramite un flag obbligatorio nel form di pubblicazione.
            </p>
          </div>
        </Section>

        <Section title="5. Aste, offerte e baratti">
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Le aste hanno durata definita dal venditore (1, 3, 7 o 14 giorni). Il rilancio minimo è di €3.</li>
            <li>Il venditore può impostare un prezzo "Compralo subito" opzionale, che chiude immediatamente l'asta.</li>
            <li>Chi è in testa allo scadere si aggiudica il bene e si impegna ad acquistarlo.</li>
            <li>Le offerte e i baratti sono vincolanti se accettati dal venditore.</li>
            <li>Le proposte di baratto possono includere un conguaglio in denaro.</li>
          </ul>
        </Section>

        <Section title="6. Pagamenti e commissioni">
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Per gli account <strong>Privato</strong>: pubblicazione annunci, partecipazione ad aste e baratti sono <strong>gratuiti</strong>.</li>
            <li>Per gli account <strong>Azienda</strong>: iscrizione annuale obbligatoria di <strong>€9,99/anno</strong> + commissione di <strong>€0,50</strong> per ogni annuncio pubblicato.</li>
            <li>Sono opzionali a pagamento i servizi <strong>Vetrina Premium</strong> (€4,99/7gg o €14,99/30gg) per maggiore visibilità.</li>
            <li>Tutti i pagamenti sono gestiti da <strong>Stripe</strong>. La piattaforma non conserva dati di carte di credito.</li>
            <li>La piattaforma non gestisce i pagamenti tra venditore e acquirente per le transazioni private.</li>
          </ul>
        </Section>

        <Section title="7. Chat e comunicazioni">
          <p>
            Per la tutela della tua privacy, i numeri di telefono ed email scritti in chat vengono <strong>automaticamente censurati</strong> con "xxxxx". Ti chiediamo di mantenere le comunicazioni educate e di non condividere dati sensibili.
          </p>
        </Section>

        <Section title="8. Limitazione di responsabilità">
          <p>
            SAN MARINO MARKET fornisce la piattaforma "as-is". Non garantiamo l'accuratezza degli annunci, la qualità o l'autenticità dei beni venduti, né l'esito delle transazioni. Non siamo responsabili di danni diretti, indiretti, consequenziali o di mancato guadagno derivanti dall'uso del servizio o da transazioni effettuate tra utenti.
          </p>
        </Section>

        <Section title="9. Sospensione e chiusura">
          <p>
            Possiamo sospendere o chiudere account che violino questi Termini, inclusa la clausola sui prodotti contraffatti. L'utente può cancellare il proprio account in qualsiasi momento dal profilo. La cancellazione comporta l'eliminazione di tutti i dati associati entro 30 giorni.
          </p>
        </Section>

        <Section title="10. Legge applicabile e foro">
          <p>
            Questi Termini sono regolati dalla legge della Repubblica di San Marino. Per ogni controversia è competente il foro di San Marino.
          </p>
        </Section>

        <Section title="11. Modifiche">
          <p>
            Possiamo aggiornare questi Termini in qualsiasi momento. Le modifiche entrano in vigore alla pubblicazione su questa pagina. L'uso continuativo del servizio comporta l'accettazione dei Termini aggiornati.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-xl font-black text-[#1d3d3a] mb-2">{title}</h2>
      <div className="text-sm leading-relaxed">{children}</div>
    </section>
  );
}
